const sessionTimestamp = Date.now().toString();

export function getSessionTimestamp(): string {
  return sessionTimestamp;
}

/** Keeps one cache key per page load without changing existing query parameters. */
export function withSessionTimestamp(url: string): string {
  if (!url) return url;

  const hashIndex = url.indexOf('#');
  const resource = hashIndex === -1 ? url : url.substring(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.substring(hashIndex);
  const queryIndex = resource.indexOf('?');
  const query = queryIndex === -1 ? '' : resource.substring(queryIndex + 1);

  if (new URLSearchParams(query).has('t')) return url;

  const separator = queryIndex === -1 ? '?' : /[?&]$/.test(resource) ? '' : '&';
  return `${resource}${separator}t=${sessionTimestamp}${hash}`;
}
